/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formpurpose_Startdate_Label_6monthsto1year3Inputs */

const ja_contact_formpurpose_startdate_label_6monthsto1year3 = /** @type {(inputs: Contact_Formpurpose_Startdate_Label_6monthsto1year3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6ヶ月から1年以内`)
};

const en_contact_formpurpose_startdate_label_6monthsto1year3 = /** @type {(inputs: Contact_Formpurpose_Startdate_Label_6monthsto1year3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Between 6 months and 1 year`)
};

/**
* | output |
* | --- |
* | "Between 6 months and 1 year" |
*
* @param {Contact_Formpurpose_Startdate_Label_6monthsto1year3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formpurpose_startdate_label_6monthsto1year3 = /** @type {((inputs?: Contact_Formpurpose_Startdate_Label_6monthsto1year3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formpurpose_Startdate_Label_6monthsto1year3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formpurpose_startdate_label_6monthsto1year3(inputs)
	return en_contact_formpurpose_startdate_label_6monthsto1year3(inputs)
});
export { contact_formpurpose_startdate_label_6monthsto1year3 as "contact_formPurpose_startDate_label_6monthsTo1year" }